import React, { createContext, useContext, useCallback, useState, useRef } from 'react';
import { ToastContainer } from '../components/Toast';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  const push = useCallback((type, text, duration = 4500) => {
    const id = ++idRef.current;
    setToasts(t => [...t, { id, type, text }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), duration);
    return id;
  }, []);

  const dismiss = useCallback((id) => setToasts(t => t.filter(x => x.id !== id)), []);

  const success = useCallback((text, dur) => push('success', text, dur), [push]);
  const error   = useCallback((text, dur) => push('error',   text, dur), [push]);
  const info    = useCallback((text, dur) => push('info',    text, dur), [push]);

  return (
    <ToastContext.Provider value={{ success, error, info, dismiss }}>
      {children}
      <ToastContainer toasts={toasts} onDismiss={dismiss} />
    </ToastContext.Provider>
  );
}

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
};
